// sets cookie for automatic timezone detection server-side
// https://github.com/kbaum/browser-timezone-rails/blob/master/app/assets/javascripts/browser_timezone_rails/set_time_zone.js.erb
module.exports = function () {
  if (location.protocol == 'https:') {
    // SameSite=None so the cookie survives the iframe case; Partitioned only
    // in embedded (LTI iframe) contexts, mirroring the server-side middleware.
    let cookie = `browser.timezone=${
      Intl.DateTimeFormat().resolvedOptions().timeZone
    };path=/;secure;SameSite=None`
    if (window._E?.embedded) cookie += ';Partitioned'
    window.document.cookie = cookie
  } else {
    window.document.cookie = `browser.timezone=${
      Intl.DateTimeFormat().resolvedOptions().timeZone
    };path=/`
  }
}
